class BlogPost extends HTMLElement {
  constructor() {
    super();
    this.prevButton = null;
    this.nextButton = null;
    this.scrollContainer = this;
    this._scrollTimeout = null;
    this._resizeTimeout = null;
  }

  _throttle(fn, wait) {
    let lastTime = 0;
    return (...args) => {
      const now = Date.now();
      if (now - lastTime >= wait) {
        lastTime = now;
        fn.apply(this, args);
      }
    };
  }

  connectedCallback() {
    const section = this.closest('[id^="shopify-section"]');
    this.prevButton = section.querySelector('button[is="prev-button"]');
    this.nextButton = section.querySelector('button[is="next-button"]');

    this.handlePrev = this.handlePrev.bind(this);
    this.handleNext = this.handleNext.bind(this);
    this.updateButtonStates = this.updateButtonStates.bind(this);
    
    this._throttledScrollHandler = this._throttle(this.updateButtonStates, 100);
    this._throttledResizeHandler = this._throttle(this.updateButtonStates, 150);

    if (this.prevButton && this.nextButton) {
      this.prevButton.addEventListener('click', this.handlePrev);
      this.nextButton.addEventListener('click', this.handleNext);
    }

    this.addEventListener('scroll', this._throttledScrollHandler, { passive: true });
    window.addEventListener('resize', this._throttledResizeHandler, { passive: true });

    requestAnimationFrame(this.updateButtonStates);
  }

  handlePrev() {
    const scrollAmount = this.getScrollAmount();
    this.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
  }

  handleNext() {
    const scrollAmount = this.getScrollAmount();
    this.scrollBy({ left: scrollAmount, behavior: 'smooth' });
  }

  getScrollAmount() {
    const firstItem = this.querySelector('.blog-post-card');
    if (!firstItem) return this.offsetWidth / 3;
    const style = getComputedStyle(this);
    const gap = parseFloat(style.columnGap || 0);
    const isAtStart = this.scrollLeft -this.scrollWidth <= 0;
    const isAtEnd = this.scrollLeft >= this.scrollWidth;
    return firstItem.offsetWidth + (isAtStart || isAtEnd ? 0 : gap);
  }

  updateButtonStates() {
    if (!this.prevButton || !this.nextButton) return;
    const maxScrollLeft = this.scrollWidth - this.clientWidth;

    this.prevButton.disabled = this.scrollLeft <= 0;
    if(this.prevButton.disabled) {
        this.prevButton.style.display = 'none';
    } else 
        this.prevButton.style.display = 'block';

    this.nextButton.disabled = this.scrollLeft >= maxScrollLeft - 1;
    if(this.nextButton.disabled) {
        this.nextButton.style.display = 'none';
    } else 
        this.nextButton.style.display = 'block';
  }

  disconnectedCallback() {
    if (this.prevButton && this.nextButton) {
      this.prevButton.removeEventListener('click', this.handlePrev);
      this.nextButton.removeEventListener('click', this.handleNext);
    }
    this.removeEventListener('scroll', this._throttledScrollHandler);
    window.removeEventListener('resize', this._throttledResizeHandler);
  }
}

customElements.define('blog-post', BlogPost);
